/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import CircularProgress from 'components/CircularProgress';
import DefaultAvatar from 'components/common/DefaultAvatar';
import { DEFAULT_FORMAT_DATE_INPUT_US } from 'constants/days';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import moment from 'moment';
import React from 'react';

import { IAppointmentListInMessageTabProps } from '../AppointmentListInMessageTab/types';
import { checkUserIsInChatRoom } from '../hooks';

const MobileAppointmentListInMessageTab: React.FC<IAppointmentListInMessageTabProps> = ({
  // transaction,
  loading,
  onAppointmentClick,
  selectedChatRoom,
  chatRooms,
}) => {
  const userId = useCurrentLoggedInUser().id;
  return (
    <div
      className={`z-10 block md:hidden top-0 left-0 w-full h-full absolute bg-white border-t border-border_color transition-all ${
        selectedChatRoom ? '-left-full' : 'left-0'
      }`}>
      {loading ? (
        <CircularProgress />
      ) : (
        chatRooms?.map((chatRoom) => {
          const { appointment } = chatRoom;
          if (!appointment) return null;
          const appointmentId = appointment.id;
          const appoinmentDate = moment(appointment.date).format(DEFAULT_FORMAT_DATE_INPUT_US).toString();
          return (
            <div
              key={appointmentId}
              onClick={() => {
                onAppointmentClick?.(chatRoom);
              }}
              className='!p-0 conversation-card flex items-center space-between border-b border-border_color'>
              <div className='p-5 flex-1 flex items-center'>
                Appointment {appoinmentDate}
                {chatRoom?.unreadMessagesCount && checkUserIsInChatRoom(userId, chatRoom) ? (
                  <div className='ml-2'>
                    <DefaultAvatar bgColor='red'>{chatRoom.unreadMessagesCount}</DefaultAvatar>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          );
        })
      )}
      {(chatRooms?.length || 0) === 0 && <div className='p-5'>No Appointment thread </div>}
    </div>
  );
};
export default React.memo(MobileAppointmentListInMessageTab);
